import type { Messages } from './en.ts';

export const uk: Messages = {
  app: {
    name: 'Salt & Shot',
    shortName: 'Salt & Shot',
    subtitle: 'Морська тактика',
    tagline: 'Тактична гра під вітрилами й парою',
    skipToContent: 'Перейти до змісту',
    loading: 'Беремо проміри…',
  },
  nav: {
    label: 'Головна навігація',
    profile: 'Профіль',
    logbook: 'Судновий журнал',
    harbour: 'Гавань',
    newGame: 'Нова гра',
    comingSoon: 'незабаром',
    newGameFailed: 'Не вдалося почати гру. Спробуйте ще раз.',
    signIn: 'Увійти',
    join: 'Вступити до флоту',
    signOut: 'Вийти',
    language: 'Мова',
  },
  landing: {
    pageTitle: 'Salt & Shot',
    chartTitle: 'Нова й достовірна мапа',
    chartSubtitle: 'тактики вітрила й пари',
    lead: 'Командуйте флотилією бригів, фрегатів і колісних пароплавів. Читайте вітер, стережіться рифів і гармат фортів і приведіть кораблі до Королівського порту.',
    features: {
      wind: 'Вертушка вітру вирішує, хто йде під вітрилами, а хто мусить лавірувати.',
      steam: 'Вітрило й рання пара в одному флоті: швидкість проти навітряного положення.',
      ports: 'Форти, порти й Королівський порт визначають кожен бій.',
    },
    playGuest: 'Зіграти проти комп’ютера',
    playGuestNote: 'Без реєстрації: мала мапа, проти комп’ютера.',
    published: 'Гравійовано для Адміралтейства жодної певної держави',
  },
  profile: {
    pageTitle: 'Профіль капітана',
    title: 'Профіль капітана',
    particulars: 'Відомості про капітана',
    serviceSince: 'На службі з {{date}}',
    lastSeen: 'Востаннє на борту {{date}}',
    email: 'Е-пошта',
    emailUnknown: 'Е-пошту не вказано',
    register: 'Суднова книга',
    registerHint: 'Так вас бачитимуть інші капітани у списках флоту.',
    nickname: 'Псевдонім',
    nicknameHint: '3–20 літер, цифр, «_» або «-». Має бути унікальним у флоті.',
    displayName: 'Ім’я',
    displayNameHint: 'Показується поруч із псевдонімом. До 40 символів.',
    save: 'Внести до книги',
    saving: 'Записуємо…',
    saved: 'Внесено до книги.',
    languageTitle: 'Мова',
    languageHint: 'Мова мап, журналів і наказів. Зберігається у вашому профілі.',
    loadFailed: 'Не вдалося отримати ваші документи. Можливо, втрачено сигнал — спробуйте трохи згодом.',
    retry: 'Спробувати ще',
  },
  avatars: {
    'pennant-yellow': 'Жовтий вимпел',
    'pennant-green': 'Зелений вимпел',
    'pennant-crimson': 'Багряний вимпел',
    'pennant-slate': 'Сизий вимпел',
    'burgee-gold': 'Золотий брейд-вимпел',
    'burgee-blue': 'Синій брейд-вимпел',
    'signal-alpha': 'Сигнальний прапор «Альфа»',
    'signal-bravo': 'Сигнальний прапор «Браво»',
    'signal-delta': 'Сигнальний прапор «Дельта»',
    'signal-kilo': 'Сигнальний прапор «Кіло»',
    'signal-november': 'Сигнальний прапор «Новембер»',
    'signal-papa': 'Сигнальний прапор «Папа»',
    'signal-uniform': 'Сигнальний прапор «Юніформ»',
    'signal-zulu': 'Сигнальний прапор «Зулу»',
  },
  newGame: {
    title: 'Нова гра',
    close: 'Закрити',
    how: 'Як грати',
    fleet: { red: 'Ваш флот', blue: 'Флот супротивника', colour: 'Колір' },
    bot: { name: 'Проти комп’ютера', hint: 'Ви ведете перший флот, комп’ютер відповідає одразу.' },
    online: {
      name: 'З другом у мережі',
      hint: 'Ви отримаєте посилання для друга; гра почнеться, коли він його прийме.',
    },
    hotseat: {
      name: 'Удвох за одним екраном',
      hint: 'Обидва флоти на цьому пристрої; передавайте його щоходу.',
    },
  },
  logbook: {
    pageTitle: 'Судновий журнал',
    title: 'Судновий журнал',
    lead: 'Ваші походи й бої, записані за датою.',
    emptyTitle: 'Стоїмо на якорі',
    emptyBody: 'До журналу ще не внесено жодного походу. Почніть гру — і ваші бої буде записано тут.',
    columns: {
      opponent: 'Суперник',
      status: 'Стан',
      turn: 'Хід',
      updated: 'Останній запис',
    },
    openInvite: 'Очікуємо суперника',
    hotseat: 'За одним екраном: обидва флоти',
    bot: 'Проти комп’ютера',
    open: 'Відкрити',
    status: {
      pending: 'Збір',
      active: 'У поході',
      finished: 'Завершено',
      abandoned: 'Покинуто',
    },
    turn: {
      mine: 'Ваш хід',
      theirs: 'Хід суперника',
      none: '—',
    },
    side: {
      yellow: 'Жовтий флот',
      green: 'Зелений флот',
    },
  },
  harbour: {
    pageTitle: 'Гавань',
    title: 'Ласкаво просимо на борт',
    welcome: 'Ласкаво просимо на борт, {{rank}} {{name}}',
    watches: {
      middle: 'Собача вахта',
      morning: 'Ранкова вахта',
      forenoon: 'Передполуденна вахта',
      afternoon: 'Післяполуденна вахта',
      firstDog: 'Перша напіввахта',
      lastDog: 'Друга напіввахта',
      first: 'Вечірня вахта',
    },
    bells: {
      b1: 'одна склянка',
      b2: 'дві склянки',
      b3: 'три склянки',
      b4: 'чотири склянки',
      b5: 'п’ять склянок',
      b6: 'шість склянок',
      b7: 'сім склянок',
      b8: 'вісім склянок',
    },
    ranks: {
      midshipman: 'мічман',
      lieutenant: 'лейтенант',
      commander: 'капітан-лейтенант',
      captain: 'капітан',
      commodore: 'комодор',
      rearAdmiral: 'контрадмірал',
    },
    helm: {
      kicker: 'На містку',
      yourMove: 'Чекаємо на ваші накази',
      theirMove: 'Хід супротивника',
      turn: 'хід {{n}}',
      lastEntry: 'Останній запис у журналі — {{when}}.',
      take: 'Стати до штурвала',
      look: 'Поглянути на мапу',
      more: 'Ще ігор чекають на ваші накази: {{n}}',
      calmTitle: 'На палубі тихо',
      calmBody: 'Боїв зараз немає. Оберіть флоти й виходьте в море.',
    },
    record: {
      title: 'Послужний список',
      voyages: 'Походів',
      underWay: 'У морі',
      concluded: 'Завершено',
      rank: 'Звання',
      next: 'Наступне: {{rank}}, після {{n}} завершених боїв.',
      openLog: 'Відкрити судновий журнал',
    },
    order: {
      title: 'Наказ по флоту',
      signed: 'Адмірал',
      next: 'Наступний наказ',
    },
    orders: {
      o1: 'Беріть до ескадри лише ті кораблі, що підуть у хід: решта стоїть на місці й однаково може стріляти.',
      o2: 'Свіжий вітер найшвидше несе за вітром; кожен румб до вітру коштує клітинки.',
      o3: 'Обходьте форти стороною, якщо не збираєтеся змусити їхні гармати замовкнути.',
      o4: 'Пошкоджений корабель у своєму порту може стати в док, якщо не стріляв: щоходу латається одна пробоїна.',
      o5: 'Пам’ятайте про рифи — на мапі вони червоні: крізь них не пройде жоден кіль.',
      o6: 'Наведіть курсор на ворога перед маневром: мапа покаже, чиї гармати до нього дістануть.',
      o7: 'Королівський порт супротивника — головний приз. Тримайте корабель-другий біля свого.',
      o8: 'Парі вітер не указ: тримайте пароплав під рукою на випадок штилю.',
      o9: 'Залп кидає кості один раз на всі гармати: влучання пробиває всі діри разом, промах марнує всі постріли. Ним топлять великий корабель одним ударом.',
      o10: 'Невистріляні ядра пропадають наприкінці ходу: якщо ціль у межах пострілу, стріляйте.',
      o11: 'Біля рифів ходіть малою ескадрою: шторм жене лише зібрані кораблі, а риф розбиває кожного, кого спіймає.',
      o12: 'Корабель на Королівському порту супротивника не стріляє. Не беріть його в ескадру — і шторм його не зрушить.',
      o13: 'Полеглий форт не втрачено назавжди: займіть порт своїми кораблями, без ворога поруч, — і над фортом підніметься ваш прапор.',
      o14: 'Якщо форт упаде, усі кораблі в його доці йдуть на дно. Ставайте в док лише за міцним фортом.',
      o15: 'Земля й форти закривають постріл, кораблі й рифи — ні. Знайдіть чисту лінію, перш ніж зближуватися.',
      o16: 'У штиль вітрила висять, а весла й пара йдуть у будь-який бік: штиль — година галери.',
      o17: 'Два кораблі на морську клітинку, один — на прибережну: оберіть стоянку до того, як підняти вітрила, інакше не дійдете.',
      o18: 'Поки форт стоїть, жоден ворог не ввійде у ваш порт: цілий форт — найкращі ворота.',
    },
  },
  invite: {
    against: 'проти',
    waiting: {
      pageTitle: 'Чекаємо на суперника',
      kicker: 'Гра в мережі',
      title: 'Чекаємо на суперника',
      body: 'Надішліть це посилання капітану, з яким хочете битися. Гра відкриється тут, щойно він його прийме.',
      linkLabel: 'Посилання-запрошення',
      copy: 'Скопіювати посилання',
      copied: 'Скопійовано',
      expires: 'Посилання дійсне до {{date}}.',
      notYours: 'Чекаємо, поки другий капітан прийме запрошення.',
    },
    join: {
      pageTitle: 'Виклик на бій',
      kicker: 'Гра в мережі',
      title: 'Виклик на бій',
      body: 'Капітан {{name}} викликає вас на бій. Ви поведете другий флот.',
      own: 'Це ваше власне запрошення: надішліть посилання капітану, з яким хочете битися.',
      signIn: 'Увійти й прийняти',
      signUp: 'Вступити до флоту',
      accept: 'Прийняти командування',
      open: 'Відкрити гру',
      home: 'На титульну сторінку',
      missing: 'Такого запрошення немає. Перевірте посилання.',
      taken: 'Це запрошення вже прийняв інший капітан.',
      expired: 'Запрошення більше не дійсне. Попросіть нове посилання.',
      failed: 'Не вдалося прийняти запрошення. Спробуйте ще раз.',
    },
  },
  notFound: {
    pageTitle: 'Незвідані води',
    title: 'Незвідані води',
    body: 'Тут ще ніхто не робив промірів, і цієї сторінки немає на жодній нашій мапі.',
    back: 'Повернутися до порту',
  },
  error: {
    title: 'Штормить',
    body: 'На борту щось пішло не так. Спробуйте ще раз.',
    reload: 'Оновити',
    authTitle: 'Не вдалося піднятися на борт',
    authBody: 'Вхід не завершено. Спробуйте ще раз.',
  },
  errors: {
    nickname_taken: 'Під цим псевдонімом уже ходить інший капітан.',
    validation_failed: 'Перевірте позначені поля.',
    unauthorized: 'Сеанс завершено. Увійдіть знову.',
    network: 'Берег не відповідає. Перевірте з’єднання та спробуйте ще раз.',
    generic: 'Щось пішло не так. Спробуйте ще раз.',
    nickname_charset: 'Лише літери, цифри, «_» або «-».',
    too_short: 'Закоротко.',
    too_long: 'Задовго.',
  },
  ships: {
    names: {
      first_rate: 'Лінійний трипалубний, 100 гармат',
      ship_of_line: 'Лінійний двопалубний, 60 гармат',
      sail_frigate: 'Вітрильний фрегат',
      brig: 'Бриг',
      cutter: 'Тендер',
      galleon: 'Галеон',
      galley: 'Галера',
      ironclad_battery: 'Броненосна батарея',
      steam_frigate: 'Паровий фрегат',
      steam_corvette: 'Паровий корвет',
      paddle_steamer: 'Пароплав',
      monitor: 'Монітор',
    },
    guns: {
      first_rate: '100 гармат',
      ship_of_line: '60 гармат',
      sail_frigate: '40 гармат',
      brig: '14 гармат',
      cutter: '8 гармат',
      galleon: '30 гармат',
      galley: '8 гармат',
      ironclad_battery: '40 важких гармат',
      steam_frigate: '30 гармат',
      steam_corvette: '20 гармат',
      paddle_steamer: '10 гармат',
      monitor: '2 важкі баштові гармати',
    },
    sides: {
      red: 'Жовтий флот',
      blue: 'Зелений флот',
    },
    token: {
      label: '{{ship}}, {{nation}}',
      damage: 'пробоїн: {{damage}} з {{max}}',
      sunk: 'потоплено',
      anchored: 'на якорі',
      repairing: 'у ремонті',
    },
    card: {
      label: 'Картка: {{ship}}',
      alt: 'Акварельна ілюстрація: {{ship}}',
      stats: 'Характеристики',
      fresh: 'Свіжий вітер',
      calm: 'Штиль',
      storm: 'Знесення в бурю',
      cannotMove: 'не ходить',
      shots: 'Пострілів за хід',
      range: 'Дальність',
      sinksAt: 'Пробоїн до потоплення',
      holes: 'Пробоїни',
      status: {
        sunk: 'Потоплено',
        repairing: 'У доці, ремонт',
        anchored: 'На якорі в порту',
        repairingFort: 'Лагодить форт',
        ready: 'Готовий',
      },
    },
  },
  game: {
    load: {
      failed: 'Не вдалося завантажити гру.',
      notFound: 'У вашому журналі немає такої гри.',
      retry: 'Спробувати ще раз',
      back: 'До журналу',
    },
    turn: 'Хід {{n}}',
    toAct: 'Ходить: {{side}}',
    phase: {
      handover: 'Передача ходу',
      replay: 'Повтор',
      waiting: 'Хід суперника',
      muster: 'Вибір ескадри',
      wind: 'Вітер',
      battle: 'Маневр і вогонь',
      over: 'Гру закінчено',
    },
    prompt: {
      handover: 'Передайте пристрій гравцеві: {{side}}.',
      portMove: 'Натисніть на підсвічену стоянку, щоб переставити корабель у порту. Це його хід на цей хід.',
      replay: 'Останній хід супротивника, крок за кроком.',
      waiting: 'Ходить {{side}}. Ви побачите його хід, поки він триває.',
      musterEmpty: 'Натискайте на кораблі на мапі, щоб зібрати ескадру, або одразу переходьте до вогню.',
      musterChosen: 'Вийдуть у море: {{n}}. Киньте вітер, коли будете готові.',
      wind: 'Кидаємо вітер…',
      battleMove:
        'Натисніть на корабель із ⛵, щоб його пересунути, або виберіть корабель і натисніть на супротивника, щоб вистрілити.',
      battleReach: 'Натисніть на підсвічену клітинку, щоб перейти туди.',
      battleIdle: 'Стріляйте або завершіть хід.',
      endSummary: 'Не всі ваші кораблі й форти зробили своє.',
      fire: 'Виберіть, хто стріляє, і стріляйте.',
      over: 'Гру закінчено.',
    },
    action: {
      cast: 'Кинути вітер (кораблів: {{n}})',
      castWind: 'Кинути вітер',
      portMove: 'Переставити в порту',
      portMoveCancel: 'Скасувати перестановку',
      portMoveHint: 'Це хід корабля на цей хід: з ескадрою він уже не піде.',
      skipSailing: 'Не рухатися, одразу до вогню',
      raiseSails: 'Підняти вітрила',
      endTurn: 'Завершити хід',
      keepPlaying: 'Продовжити хід',
      undo: 'Скасувати',
      undoNothing: 'Нічого скасовувати після останнього вітру, пострілу чи ходу.',
      allToSea: 'Усі в море',
      allExceptPort: 'Усі, крім тих, що в порту',
      clear: 'Очистити',
      startTurn: 'Почати хід',
      skipAnimation: 'Продовжити',
      noReturn: 'Не можна скасувати',
      addToSquadron: 'Додати до ескадри',
      removeFromSquadron: 'Прибрати з ескадри',
    },
    confirmCast: {
      title: 'Кинути вітер?',
      body: 'Вітер кидають один раз за хід, для всієї ескадри. Кораблі поза ескадрою цього ходу не рухаються — але стріляти зможуть. Скасувати кидок не можна.',
      confirm: 'Кинути вітер',
      back: 'Назад',
      dontAsk: 'Більше не питати',
    },
    handover: {
      title: 'Хід: {{side}}',
      first: 'Перший хід: {{side}}.',
      firstByLot: 'Жереб кинуто: перший хід — {{side}}.',
    },
    wind: {
      fresh: 'Свіжий вітер, дме на {{dir}}: найшвидше йти за вітром.',
      calm: 'Штиль: рухатися можуть лише веслові та парові судна.',
      storm: 'Буря, несе на {{dir}}: ескадру зносить за вітром.',
      movers: 'Можуть піти: {{n}} з {{total}}.',
      title: 'Вітер',
    },
    weather: {
      fresh: 'Свіжий вітер',
      calm: 'Штиль',
      storm: 'Буря',
    },
    dir: {
      N: 'північ',
      NE: 'північний схід',
      E: 'схід',
      SE: 'південний схід',
      S: 'південь',
      SW: 'південний захід',
      W: 'захід',
      NW: 'північний захід',
    },
    fire: {
      inSights: 'Під прицілом: стрільців {{n}}, пострілів {{shots}}',
      title: 'Вогонь по цілі: {{target}}',
      holes: 'Пробоїни: {{n}} з {{max}}',
      fortHits: 'Влучання: {{n}} з {{max}}',
      shots: 'пострілів: {{n}}',
      distance: 'дистанція {{n}}',
      fewer: 'Менше пострілів: {{unit}}',
      more: 'Більше пострілів: {{unit}}',
      staysInPort: 'до кінця ходу лишиться в порту',
      sinks: 'влучання потопить ціль',
      holesAfter: 'у разі влучання: {{n}} пробоїн з {{max}}',
      destroys: 'влучання зруйнує форт',
      hitsAfter: 'у разі влучання: {{n}} влучань з {{max}}',
      volley: 'Залп (гармат: {{n}})',
      oneByOne: 'Стріляти по одному',
      shoot: 'Вогонь',
      stop: 'Стоп',
      close: 'Закрити',
      noReturn: 'Постріл не можна скасувати',
      hit: 'Влучання!',
      miss: 'Промах.',
      none: 'Виберіть, хто стріляє.',
    },
    unit: {
      named: '«{{name}}»',
      ship: '{{cls}} №{{n}}',
      fortFirst: 'Форт першої лінії {{n}}',
      fortSecond: 'Форт другої лінії {{n}}',
      fort: 'Форт {{name}}',
      fortClass: {
        first_line: 'Форт першої лінії',
        second_line: 'Форт другої лінії',
      },
    },
    log: {
      title: 'Журнал',
      turn: 'Хід {{n}} · {{side}}',
      wind: '{{side}}: вітер кинуто для кораблів: {{n}}. {{weather}}, на {{dir}}.',
      drift: '{{ship}}: буря знесла {{from}} → {{to}}.',
      sailed: '{{ship}}: перехід {{from}} → {{to}}.',
      inPort: '{{ship}}: перейшов усередині порту на {{to}}.',
      anchored: '{{ship}}: викинуто до берега біля {{cell}}, став на якір.',
      wrecked: '{{ship}}: розбито об риф біля {{cell}}.',
      shot: '{{shooter}}: постріл по цілі {{target}} — {{result}}.',
      volley: 'Залп із {{n}} гармат ({{shooters}}) по цілі {{target}} — {{result}}.',
      miss: 'промах',
      hit: 'влучання',
      holes: 'влучання, пробоїн {{n}} з {{max}}',
      sunk: 'влучання, потоплено',
      fortHits: 'влучання, {{n}} з {{max}}',
      destroyed: 'влучання, форт зруйновано',
      sunkInDock: '{{ship}}: затонув у доці разом із фортом.',
      dock: '{{ship}}: у доці, ремонт ходів: {{n}}.',
      repaired: '{{ship}}: відремонтовано, пробоїн лишилося {{n}}.',
      dockLeft: '{{ship}}: вийшов із доку, готовий до походу.',
      fortRepair: '{{side}}: почато ремонт — {{fort}}.',
      fortRepairStopped: {
        voluntary: '{{fort}}: ремонт зупинено.',
        crew_lost: '{{fort}}: ремонт зупинено, команда загинула.',
        fort_destroyed: '{{fort}}: ремонт зупинено, форт зруйновано.',
        completed: '{{fort}}: ремонт завершено.',
      },
      fortRepaired: '{{fort}}: відремонтовано, пошкоджень лишилося {{n}}.',
      captured: '{{fort}}: тепер під прапором — {{side}}.',
      royalHold: '{{side}}: Королівський порт супротивника утримується, {{n}} з {{max}}.',
      royalLost: '{{side}}: Королівський порт супротивника втрачено.',
      drawOffered: '{{side}}: запропоновано нічию.',
      drawExpired: '{{side}}: пропозиція нічиєї спливла.',
      drawAccepted: '{{side}}: нічию прийнято.',
      resigned: '{{side}}: здача.',
      endTurn: '{{side}}: хід завершено.',
      show: 'Показати на мапі',
      empty: 'Поки нічого не сталося.',
      filter: {
        all: 'Усі',
        wind: 'Вітер',
        move: 'Рух',
        fire: 'Стрільба',
        repair: 'Ремонт і захоплення',
        turn: 'Ходи',
      },
      export: 'Експорт',
    },
    roster: {
      title: 'Флот',
      mine: 'Ваш флот',
      theirs: 'Супротивник',
      forts: 'Форти',
      afloat: 'на плаву {{n}} з {{total}}',
      filter: {
        label: 'Показати',
        canAct: 'Можуть діяти',
        all: 'Усі',
        squadron: 'Ескадра',
        damaged: 'Пошкоджені',
        inPort: 'У порту',
      },
      status: {
        inSquadron: 'в ескадрі',
        toMove: 'може піти',
        moved: 'ходив',
        fired: 'стріляв',
        shots: 'пострілів {{n}}',
        dock: 'у доці {{n}}',
        crew: 'лагодить форт',
        inPort: 'у порту',
        sunk: 'потоплено',
        destroyed: 'зруйновано',
      },
      none: 'Таких кораблів немає.',
    },
    view: {
      tools: 'Вигляд',
      myFleet: 'Мій флот',
      chart: 'Мапа згори',
      perspective: 'Перспектива',
      log: 'Журнал',
      keys: 'Клавіші',
      show: 'Показати',
    },
    keys: {
      title: 'Клавіатура',
      close: 'Закрити',
      space: 'Кинути вітер · пропустити анімацію',
      tab: 'Наступний / попередній корабель, що може діяти',
      arrows: 'Курсор по клітинках (якщо вибрано корабель) · зсув мапи',
      enter: 'Кинути вітер · хід до курсора · вогонь · завершити хід',
      f: 'Навести вибраний корабель на наступну ціль',
      v: 'Залп: усі, хто дістає до цілі',
      s: 'Додати вибраний корабель до ескадри або прибрати',
      a: 'Усі кораблі, що можуть вийти в море, — до ескадри, або жодного',
      z: 'Скасувати',
      r: 'Переглянути останній хід суперника',
      i: 'Картка вибраного корабля',
      esc: 'Закрити · зняти вибір',
      m: 'Мій флот',
      c: 'Мапа згори',
      l: 'Журнал',
      plusMinus: 'Масштаб',
      help: 'Цей список',
    },
    replay: {
      watch: 'Переглянути хід: {{side}}',
      title: 'Повтор ходу: {{side}}',
      step: 'Крок {{n}} з {{total}}',
      pause: 'Пауза',
      play: 'Далі',
      skip: 'Пропустити',
      speed: 'Швидкість',
    },
    caption: {
      portMoved: 'Переставлено в порту',
      wrecked: 'Розбито!',
      sunk: 'Потоплено!',
      destroyed: 'Форт зруйновано!',
      repaired: 'Ремонт: лишилося {{n}}',
    },
    board: {
      zoomIn: 'Наблизити',
      zoomOut: 'Віддалити',
      fit: 'Уся карта',
      minimapShow: 'Показати мінікарту',
      minimapHide: 'Сховати мінікарту',
    },
    chart: {
      fort: 'Форт',
      royalPort: 'Королівський порт',
    },
    sheet: {
      close: 'Закрити',
      view: 'Вигляд',
      picker: 'Який корабель?',
      more: 'Ще',
      card: 'Картка',
    },
    hud: {
      status: 'Стан ходу',
      tools: 'Меню гри',
      fleet: 'Флот',
      log: 'Журнал',
      minimap: 'Мінікарта',
      menu: 'Меню',
      help: 'Довідка',
      ships: 'Кораблів на плаву: {{n}} з {{total}}',
      forts: 'Фортів уціліло: {{n}} з {{total}}, пошкоджено: {{damaged}}',
      royalHold: 'Утримання ворожого Королівського порту: {{n}} з {{max}}',
      settings: 'Налаштування',
    },
    inspector: {
      state: 'Стан',
      specs: 'Характеристики',
      holes: 'Пробоїни',
      holesValue: '{{n}} з {{max}}',
      shotsLeft: 'Постріли',
      shotsValue: 'залишилось {{n}} з {{max}}',
      sailing: 'Рух',
      moveAvailable: 'До {{n}} клітинок',
      moveDone: 'Виконано',
      moveRepair: 'На ремонті',
      repair: 'Ремонт',
      repairDock: 'У доці: залишилось ходів — {{n}}',
      repairCrew: 'Команда лагодить {{fort}}',
      repairFort: 'Ремонт форту: залишилось ходів — {{n}}',
      squadron: 'Ескадра',
      guns: 'Озброєння',
      shotsPerTurn: 'Постр. за хід',
      range: 'Дальність',
      cells: '{{n}} кл.',
      fresh: 'Свіжий вітер',
      calm: 'Штиль',
      storm: 'Знос у бурю',
      noCalm: '—',
      sinksAt: 'Тоне від',
      sinksAtValue: '{{n}} пробоїн',
      hits: 'Влучання',
      expand: 'Докладніше',
      collapse: 'Згорнути',
      close: 'Закрити',
      sunk: 'Потоплений',
      destroyed: 'Зруйнований',
      moveNoSquadron: 'Не в ескадрі',
      moveAfterWind: 'Після вітру',
      moveBecalmed: 'Штиль: стоїть',
      moveStorm: 'Знесений бурею',
      moveBlocked: 'Шлях закритий',
      moveNotNow: 'Не зараз',
    },
    unitPanel: {
      holes: 'Пробоїни: {{n}} з {{max}}',
      hits: 'Влучання: {{n}} з {{max}}',
      royalHold: 'Королівський порт: {{n}} з {{max}}, лишилося {{left}}',
      shooters: 'Ваших у межах пострілу: {{n}}',
      outOfReach: 'Поза досяжністю всіх ваших кораблів і фортів.',
      move: 'Іти',
      fire: 'Вогонь',
      fireAt: 'Вогонь по ньому',
      centre: 'До нього',
      deselect: 'Зняти вибір',
      dock: 'Ремонт у доку',
      fortRepair: 'Лагодити форт ({{n}} кораблі)',
      fortRepairStop: 'Припинити ремонт',
      enemy: 'ворог',
      note: {
        afterWind: 'Піде, щойно буде кинуто вітер.',
        chooseToSail: 'Додайте до ескадри, щоб він пішов цього ходу.',
        noTargets: 'Ворога в межах пострілу немає.',
        noRoom: 'Звідси нікуди йти.',
      },
    },
    reach: {
      blocked: '{{cell}}: {{why}}',
    },
    menu: {
      title: 'Меню',
      newGame: 'Нова партія…',
      settings: 'Налаштування',
      game: 'Гра',
      developer: 'Розробнику',
      chart: 'Вигляд карти (пласкої, легше влучати)',
      watercolour: 'Акварельна карта',
      confirmCast: 'Питати перед киданням вітру',
      offerDraw: 'Запропонувати нічию',
      acceptDraw: '{{side}} приймає нічию',
      resign: '{{side}} здається',
    },
    size: {
      label: 'Розмір партії',
      start: 'Почати: {{size}}',
      small: { name: 'Мала партія', counts: '6 кораблів / 2 форти', blurb: 'Компактна морська битва.' },
      medium: {
        name: 'Середня партія',
        counts: '12 кораблів / 4 форти',
        blurb: 'Тактична битва кількох ескадр.',
      },
      large: {
        name: 'Велика партія',
        counts: '28 кораблів / 6 фортів',
        blurb: 'Повномасштабна морська кампанія.',
      },
      classic: 'Класична карта',
    },
    help: {
      title: 'Довідка',
      turn: 'Як іде хід',
      steps: {
        muster: {
          title: 'Оберіть ескадру',
          body: 'торкайтеся своїх кораблів на мапі, щоб назвати, хто піде цього ходу; обрані позначені галочкою, повторний дотик знімає вибір.',
        },
        wind: {
          title: 'Киньте вітер',
          body: 'одна вертушка на всю ескадру: свіжий вітер, штиль чи буря, і його напрям.',
        },
        battle: {
          title: 'Маневр і вогонь',
          body: 'оберіть корабель: сині клітини — куди він може піти, червоні позначки — у кого влучить. Рух і вогонь — у будь-якому порядку.',
        },
        end: { title: 'Завершіть хід', body: 'і хід перейде до іншої сторони.' },
      },
      select: 'Два кораблі в одній клітині',
      selectBody:
        'Дотик до клітини з двома кораблями відкриває невеликий список: оберіть потрібний. Обраний корабель обведено синім, ворожий — червоним.',
    },
    chartHint: {
      title: 'Перейти на мапу згори?',
      body: 'На малому екрані по клітинках пласкої мапи влучати легше. Повернутися можна будь-коли кнопкою «Мапа згори».',
      switch: 'Мапа згори',
      keep: 'Лишити перспективу',
    },
    summary: {
      title: 'Завершити хід?',
      notMoved: 'Ще не ходили: {{n}}',
      notFired: 'Ще можуть стріляти: {{n}}',
    },
    squadron: {
      title: 'Ескадра',
      in: 'В ескадрі',
      out: 'Цього ходу стоїть на місці',
      cannot: 'Не може рухатися цього ходу',
      count: 'Ескадра: {{n}} з {{total}}',
      list: 'Обрати зі списку',
    },
    over: {
      winner: '{{side}} перемагає',
      victory: 'Перемога!',
      defeat: 'Поразка',
      end: 'Гру закінчено',
      turn: 'Хід',
      afloat: '{{side}}: на плаву',
      close: 'Подивитися на мапу',
      leave: 'Вийти',
      won: 'Перемога: {{side}}',
      royal_port: 'Королівський порт утримано.',
      annihilation: 'Усі кораблі супротивника потоплено.',
      resignation: 'Супротивник здався.',
      draw: 'Нічия за згодою',
    },
  },
  why: {
    generic: 'Правила цього не дозволяють ({{rule}}).',
    gameOver: 'Гру закінчено.',
    invalidAction: 'Так зробити не можна.',
    unknownUnit: 'Такого корабля чи форту немає.',
    notYourTurn: 'Зараз хід іншої сторони.',
    notYourUnit: 'Це не ваш корабель чи форт.',
    noDrawOffer: 'Пропозиції нічиєї немає.',
    groupAlreadyCast: 'Вітер цього ходу вже кинуто.',
    invalidGroup: 'Виберіть принаймні один корабель.',
    noSquadron: 'Спершу виберіть ескадру, потім киньте вітер.',
    windNotCast: 'Спершу киньте вітер: кораблі рухаються лише після нього.',
    castWindFirst: 'Спершу киньте вітер для вибраної ескадри.',
    notInSquadron: 'Цей корабель не в ескадрі й цього ходу не рухається. Стріляти він може.',
    inSquadron: 'Кораблі ескадри йдуть за вітром, а не всередині порту.',
    stormDrifted: 'Буря вже знесла цей корабель — це і був його хід.',
    becalmed: 'Штиль: вітрильник без вітру не рухається.',
    sunk: 'Цей корабель потоплено.',
    inDock: 'Корабель у доці, на ремонті.',
    alreadyInDock: 'Корабель уже в доці.',
    onFortRepair: 'Корабель лагодить форт.',
    alreadyMoved: 'Корабель уже зробив свій хід.',
    firedInPort: 'Корабель стріляв із порту й до кінця ходу лишається в ньому.',
    notInLine: 'Кораблі ходять і стріляють лише по прямій: рядком, стовпцем або діагоналлю.',
    tooFar: 'Задалеко проти цього вітру.',
    blockedByLand: 'На шляху суходіл.',
    blockedByReef: 'На шляху риф.',
    ownRoyalPort: 'Свої кораблі не заходять до свого Королівського порту.',
    enemyPort: 'Порт охороняє ворожий форт — спершу зруйнуйте його.',
    cellFull: 'У цій клітинці немає місця.',
    portFull: 'Порт повний.',
    diagonalSqueeze: 'Прохід між берегами надто вузький.',
    shipInTheWay: 'На шляху інший корабель.',
    notInOwnPort: 'Корабель не у вашому захищеному порту.',
    notInThisPort: 'Переставити корабель можна лише на інше місце в тому самому порту.',
    invalidShots: 'Кожен стрілець має зробити принаймні один постріл.',
    noShotsLeft: 'Пострілів цього ходу не лишилося.',
    cannotFireInDock: 'Корабель у доці не стріляє.',
    cannotFireOnRepair: 'Корабель, що лагодить форт, не стріляє.',
    onEnemyRoyalPort: 'Корабель у Королівському порту супротивника не стріляє.',
    fortDestroyed: 'Форт зруйновано.',
    outOfRange: 'Задалеко для пострілу.',
    lineOfFireBlocked: 'Лінію вогню закриває суходіл.',
    friendlyTarget: 'Це ваш корабель чи форт.',
    fortCannotTargetFort: 'Форти стріляють лише по кораблях.',
    targetGone: 'Ціль уже потоплено або зруйновано.',
    volleyTooFewShooters: 'Для залпу потрібно щонайменше {{n}} кораблів або фортів.',
    notDamaged: 'Лагодити нічого: пошкоджень немає.',
    firedThisTurn: 'Корабель, що стріляв цього ходу, не може почати ремонт.',
    alreadyRepairing: 'Ремонт уже триває.',
    enemiesInPort: 'У порту кораблі супротивника.',
    notYourFort: 'Це не ваш форт.',
    wrongCrewSize: 'Для ремонту форту потрібна команда рівно з {{n}} кораблів.',
    crewNotInPort: 'Команда має стояти в порту форту.',
    noRepairHere: 'Ви не лагодите цей форт.',
  },
  learn: {
    pageTitle: 'Як грати',
    title: 'Як грати',
    lead: 'Правила Salt & Shot коротко: по сторінці на кожну частину гри.',
    open: 'Як грати',
    contents: 'Зміст',
    picture: 'Приклад на мапі: {{topic}}',
    rules: 'Правила: {{ids}}',
    back: 'Повернутися до гавані',
    hintMore: 'Докладніше…',
    hintGotIt: 'Зрозуміло',
    hintsOn: 'Показувати підказки',
    hintsReset: 'Показати всі підказки знову',
    hints: {
      muster: {
        title: 'Оберіть ескадру',
        body: 'Натисніть на кораблі, що підуть цього ходу, тоді киньте вітер. Після вітру рухається лише ескадра; решта може стріляти.',
      },
      wind: {
        title: 'Вітер кинуто',
        body: 'Оберіть корабель ескадри: сині клітини — куди він може піти. За свіжого вітру найшвидше йти за вітром, куди вказує стрілка; кожні 45° проти вітру забирають клітину.',
      },
      becalmed: {
        title: 'Не кожен корабель може йти',
        body: 'У штиль рухаються лише веслові й парові судна, а зустрічний вітер може не лишити вітрильнику жодної клітини. Стріляти він однаково може.',
      },
      storm: {
        title: 'Буря!',
        body: 'Буря знесла кожен корабель ескадри за вітром — це й був їхній хід. Кораблі поза ескадрою лишилися на місці.',
      },
      fire: {
        title: 'Супротивник у зоні вогню',
        body: 'Оберіть свій корабель і натисніть на супротивника з червоною позначкою, щоб вистрілити. Кожен постріл влучає з імовірністю {{hitPercent}}%.',
      },
      volley: {
        title: 'Можна дати залп',
        body: '{{volleyMin}} і більше кораблів можуть стріляти по одній цілі разом: влучання вирішується один раз на всіх, і в разі успіху всі постріли влучають водночас.',
      },
      damaged: {
        title: 'Пробоїна',
        body: 'Корабель тоне, коли пробоїн стає стільки, скільки вказано в його картці. У своєму порту його можна полагодити в доці.',
      },
      dock: {
        title: 'До доку',
        body: 'Пошкоджений корабель у своєму порту може стати в док, якщо не стріляв цього ходу: наприкінці кожного вашого ходу закладається одна пробоїна. У доці він не рухається й не стріляє.',
      },
      fort: {
        title: 'Під гарматами форту',
        body: 'Ворожий форт б’є по кораблях у своїй дальності в хід своєї сторони. Тримайтеся далі або підведіть кілька кораблів, щоб його розбити.',
      },
      royalPort: {
        title: 'На Королівському порту',
        body: 'Корабель, що стоїть на ворожому Королівському порту від початку до кінця ходу своєї сторони, додає до рахунку один. На {{hold}} ця сторона перемагає.',
      },
    },
    topics: {
      goal: {
        title: 'Мета',
        body: 'Два флоти вітрильників і перших пароплавів сходяться на мапі з гаванями, фортами й рифами. Перемогти можна двома способами: потопити всі кораблі супротивника або втримувати його Королівський порт {{hold}} ходи поспіль.\n\nКожен корабель і форт стоїть на мапі. Оберіть його, щоб відкрити картку: швидкість за свіжого вітру й у штиль, гармати, дальність і скільки пробоїн він витримає.',
      },
      turn: {
        title: 'Хід',
        body: 'Сторони ходять по черзі. Ваш хід — три кроки.\n\n1. Оберіть ескадру: натисніть на мапі кораблі, що підуть цього ходу, тоді «Кинути вітер». Вітер вирішить, куди й як далеко вони зможуть пройти.\n\n2. Ходіть і стріляйте в будь-якому порядку. Оберіть корабель: сині клітини — куди він може піти, червоні позначки — у кого він влучить. Стріляти можуть і кораблі поза ескадрою.\n\n3. Натисніть «Завершити хід». Кораблі в доці й на ремонті форту лагодяться, зараховується утримання ворожого Королівського порту, і ходить супротивник.\n\nРядок угорі екрана завжди пише, що робити зараз, а кругла кнопка в правому нижньому куті виконує цей крок: «Кинути вітер», потім «Завершити хід».',
      },
      muster: {
        title: 'Ескадра',
        body: 'Перш ніж кинути вітер, ви називаєте ескадру — кораблі, що підуть цього ходу. Натискайте на них на мапі, кожен обраний позначено галочкою. Після вітру рухається лише ескадра — і лише її застає буря.\n\nМожна нікого не обирати й одразу перейти до вогню. Кораблі в доці чи на ремонті форту до ескадри не входять.',
      },
      wind: {
        title: 'Вітер',
        body: 'Один кидок вертушки — на всю ескадру. Він дає напрям і погоду: свіжий вітер, штиль або бурю, усе з рівною ймовірністю.\n\nЗа свіжого вітру найшвидше йти за вітром, куди вказує стрілка; кожні 45° проти вітру забирають клітину. Бриг на малюнку проходить {{brigFast}} клітин за вітром і {{brigSlow}} просто проти нього. Веслові й парові судна ніколи не йдуть повільніше, ніж у штиль.',
      },
      movement: {
        title: 'Рух',
        body: 'Кожен хід корабля — пряма в одному з восьми напрямів, по лінії чи по діагоналі, не далі за його хід. Суходіл, форти й рифи його зупиняють. Крізь інші кораблі проходити можна, але закінчити треба там, де є місце: два кораблі в морській клітині, один у прибережній, не більше {{portLimit}} у порту.\n\nУ штиль рухаються лише веслові й парові судна — зі швидкістю штилю, у будь-якому напрямі; вітрильники чекають на вітер. Кожен корабель ходить один раз за хід.',
      },
      storm: {
        title: 'Буря',
        body: 'Буря зносить кожен корабель ескадри за вітром на його знос — одразу й чи хочете ви того, чи ні. Знос і є хід корабля цього ходу.\n\nКорабель, винесений на риф, розбивається. Притиснутий до суходолу чи до повної клітини зупиняється раніше й стає на якір. Кораблі поза ескадрою перечікують бурю на місці, тож біля рифів мала ескадра надійніша.',
      },
      fire: {
        title: 'Вогонь і залп',
        body: 'Кораблі й форти стріляють у будь-якому з восьми напрямів, не далі за свою дальність. Суходіл і форти на шляху закривають постріл; кораблі, рифи й берег — ні. Кожен постріл влучає з імовірністю {{hitPercent}}% і дає одну пробоїну; корабель тоне, коли пробоїн стає стільки, скільки вказано в його картці.\n\nЗалп — це постріли {{volleyMin}} і більше кораблів по одній цілі разом. Чи влучив залп, вирішується один раз на всіх, з тією ж імовірністю {{hitPercent}}%: влучання — ціль отримує всі пробоїни відразу, промах — усі постріли пропали. Так великий корабель топлять одним ударом. Невитрачені постріли пропадають наприкінці ходу.',
      },
      ports: {
        title: 'Порти й док',
        body: 'Поки форт стоїть, ворожі кораблі не можуть увійти у ваш порт. Усередині свого порту корабель може перейти до будь-якої іншої його клітини без вітру — це його хід.\n\nПошкоджений корабель у своєму порту може стати в док, якщо не стріляв цього ходу. Хід постановки не рахується; далі наприкінці кожного вашого ходу закладається одна пробоїна, а цілим корабель виходить із доку. У доці він не рухається й не стріляє, але по ньому можна бити, а якщо форт упаде, усі кораблі в його доці тонуть.',
      },
      forts: {
        title: 'Форти',
        body: 'Форт першої лінії робить {{fort1Shots}} постріли за хід на {{fort1Range}} клітин і падає після {{fort1Hits}} влучань; форт другої лінії — {{fort2Shots}} постріли на {{fort2Range}}, падає після {{fort2Hits}}. Форти стріляють лише в хід своєї сторони.\n\n{{crew}} ваші кораблі в порту пошкодженого форту, що не стріляли цього ходу, можуть його лагодити: по {{fortRepair}} влучання за хід, починаючи з наступного. Полеглий форт лишає свій порт відкритим морем, і той, хто полагодить його {{crew}} кораблями без ворога в порту, підніме над ним свій прапор.',
      },
      royal: {
        title: 'Королівський порт',
        body: 'Кожна сторона має один Королівський порт, без форту. Своїм кораблям заходити до нього не можна, ворожим можна — по два.\n\nКорабель на ворожому Королівському порту не стріляє, але по ньому стріляти можна. Якщо ваш корабель стоїть там від початку до кінця вашого ходу, рахунок зростає на один; якщо ні — починається знову. Хід прибуття не рахується. На {{hold}} ви перемагаєте.\n\nБуря зносить лише кораблі ескадри. Не беріть до ескадри корабель, що тримає порт, — тоді буря його не зачепить. Якщо ж він в ескадрі, буря знесе його з порту, як будь-який інший, і якщо там не лишиться іншого вашого корабля, рахунок почнеться знову.',
      },
      end: {
        title: 'Кінець гри',
        body: 'Гра закінчується, коли в сторони не лишається кораблів на плаву — потоплених і розбитих однаково, — або коли сторона втримала ворожий Королівський порт {{hold}} ходи.\n\nСторона може й здатися будь-коли чи запропонувати нічию: пропозиція чинна до кінця наступного ходу супротивника. І те, й інше — у меню гри. Завершена гра лишається у вашому судновому журналі, де можна ще раз переглянути її останній хід.',
      },
    },
  },
  shipsPage: {
    pageTitle: 'Кораблі',
    title: 'Кораблі',
    lead: 'Усі класи флоту: як ходять і як воюють.',
    intro:
      'В обох сторін однаковий флот. Клас корабля визначає, як далеко він ходить за кожної погоди і як стріляє; числа ті самі, що на його картці.',
    movement: {
      title: 'Пересування',
      body: 'Клітинок за хід. За свіжого вітру швидкість указано строго за вітром, кожні 45° проти вітру забирають клітинку; веслові й парові судна можуть натомість іти зі швидкістю штилю, якщо вона більша. У штиль ходять лише веслові й парові. Буря зносить корабель за вітром на величину знесення.',
    },
    combat: {
      title: 'Бій',
      body: 'Щоходу корабель робить свої постріли по ворогах у межах дальності й тоне, набравши стільки пробоїн, скільки вказано в колонці «Пробоїн до потоплення».',
    },
    table: {
      ship: 'Корабель',
      propulsion: 'Рушій',
      guns: 'Гармати',
      inFleet: 'У флоті',
      kinds: { sail: 'вітрила', oars: 'вітрила й весла', steam: 'вітрила й пара' },
    },
  },
  credits: {
    pageTitle: 'Подяки',
    title: 'Подяки',
    artwork: 'Графіка',
    ownArt: 'Векторні токени кораблів і графіку поля намальовано для Salt & Shot.',
    link: 'Подяки',
  },
  footer: {
    scale: 'Морські милі',
    imprint: 'Складено старанно. Не для навігації.',
  },
};
